import {
  any, boolean, date, dateDay,
  dateMinute, nullable, number, object,
  string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PublicShowMask = {
  allowsVideographer: boolean,
  announceTime: dateDay | nullable,
  artistCollectsTax: boolean,
  artistId: string | nullable,
  artistSplitPercent: number,
  bandMembers: string,
  bioHTML: string,
  cancelledAt: date | nullable,
  capacity: number,
  collaborators: any,
  createdAt: any,
  currencyOverride: string | nullable,
  displayAddress: boolean,
  doorsTime: dateMinute | nullable,
  endTime: dateMinute | nullable,
  finished: boolean,
  finishedAt: date | nullable,
  hasExternalTickets: boolean,
  hasMerch: boolean,
  hasMultiPartySupport: boolean,
  hasPublicTickets: boolean,
  hasSocanFee: boolean,
  hasSplitTicketSales: boolean,
  hasVenuePaymentAutomation: boolean,
  hostCollectsTax: boolean,
  hostSplitPercent: number,
  isCancelled: boolean,
  isIncomplete: boolean,
  isOnlineOnly: boolean,
  isPending: boolean,
  isPublished: boolean,
  isVimeoShow: boolean,
  isZoomShow: boolean,
  links: any,
  masterThreadId: string | nullable,
  maximumPurchaseQuantity: number,
  messageFromHost: string,
  numReviews: number,
  outdoors: boolean,
  outdoorsRainOrShine: boolean,
  openerDescription: string,
  owner: string,
  ownerProfileId: string,
  pendingAt: date | nullable,
  postalCode: string,
  privateUpdatedAt: date,
  publicAct: any,
  publicVenue: any,
  publicImageUrl: any | nullable,
  score: number,
  showSalesRestriction: string,
  sidedoorSplitPercent: number,
  startTime: dateMinute | nullable,
  stripeSKU: string | nullable,
  taxRate: number,
  threadId: string | nullable,
  ticketEndTime: dateMinute | nullable,
  ticketPrice: number,
  timezoneOverride: string | nullable,
  tipButtonLabel: string,
  tipButtonUrl: string,
  title: string,
  unitPrice: number,
  updatedAt: any,
  usesOnlineFormulas: boolean,
  usesNewConnect: boolean,
  venueId: string | nullable,
  videoUrl: string,
  isHyperwalletShow: boolean,
  hasVariablePrice: boolean,
  minimumPrice: number,
  chatLocked: boolean,
  chatEnabled: boolean,
  moderators: any,
  geoGating: string | nullable,
  includedLocations: any | nullable,
  excludedLocations: any | nullable,

  // MUX
  isMuxShow: boolean,
  isLiveStream: boolean | nullable,
  isReplayAvailable: boolean | nullable,
  muxClipGenerated: boolean | nullable,
  streamIsLive: boolean | nullable,
  streamIsLiveAt: date | nullable,

  // Media
  soundcloudUri: string,
  soundcloudUriCache: object,
  spotifyUri: string,
  spotifyUriCache: object,
  youtubeUri: string,
  youtubeUriCache: object,
  vimeoUri: string,
  vimeoUriCache: object,
  bandcampUri: string,
  bandcampUriCache: object,

  // Show Series
  isShowGroup: boolean,
  showGroups: any | nullable,
  numShowsInGroupPublished: number,
  numShowsInGroupIncomplete: number,
  endTimezoneOverride: string | nullable,
  startTimezoneOverride: string | nullable,

  // Location
  fuzzyLatLng: any,
  city: string,
  region: string | nullable,
  country: string,

  // Profile updates
  profileIds: any,
  publicProfiles: any,
  profileHash: string,
};
